import React, { useState } from 'react';
import './App.css';
import IntroScreen from './components/IntroScreen';
import MusicPlayer from './components/MusicPlayer';
import StarField from './components/StarField';

const STORYBOARD = [
  { time: 0, text: "Kaleshi Roast: Priyanshu Edition 😈", img: "p11.jpeg", layout: "center" },

  { time: 3, text: "Happy Birthday To You Jee, cake shake hai toh phir bulao jee. Aise hi tum buddhe hote rahoge humko usse", img: "p1.jpeg", layout: "bottom" },

  { time: 13, text: "Kya matlab batao jee, Happy Birthday To You haan jee. Is pe itne khush kyu ho aiwe hi tum to", img: "04_personality_portrait.jpg", layout: "left" },

  { time: 22, text: "Barson pehle hi nikal chuke ho, toh birthday wala natak ye kyu hai bhai. Kyu hai bhai candle sandal phoonk se", img: "p7.jpeg", layout: "right" },

  { time: 30, text: "Bujha ke besuron ki bheed faltu mein lagwa ke. Birthday wala song zor zor se gawate ho. Humse taalishali", img: "p3.jpeg", layout: "bottom" },

  { time: 38, text: "Ka hajamat karwate ho. Ye sab nautanki phir bhi chalo jhel le. Cake shake aur starters bhar bhar ke", img: "p10.jpeg", layout: "left" },

  { time: 45, text: "Aaye plate mein ghar jaake phir se dinner na mangwana ho, chuhe na daude pet mein raat ke paune do", img: "p11.jpeg", layout: "right" },

  { time: 52, text: "Happy Birthday To You Jee, soch samajh ke invite bhijwao ji. Agar petpooja ka full intezaam hai toh hi", img: "p8.jpeg", layout: "center" },

  { time: 62, text: "Nyota consider karenge jee. Happy Birthday To You keh diya hai jee, tum aur bhi buddhee ho gaye oh teri", img: "02_achieve_dreams.jpg", layout: "bottom" },

  { time: 71, text: "Dil chhota na karo umar ka hai kya, baal jhadenge daant girenge waise hi waise hi", img: "p6.jpeg", layout: "left" },

  { time: 83, text: "Dekho koi purana gift hum jo dhoondh paaye, expect tabhi karna hum kuch haath mein lekar aaye. You Are", img: "p5.jpeg", layout: "right" },

  { time: 90, text: "On My Friend List ye nahi mazaak hai, hum time nikaal ke aa gaye toh badi baat hai. Waise sach", img: "p9.jpeg", layout: "center" },

  { time: 97, text: "Batao tum ab kitne saal ke hue, humko kya padi hai hum kisi ko na bataye. Muh na bigaad aaj tumhara", img: "p13.jpeg", layout: "bottom" },

  { time: 104, text: "Birthday hai tum akele ho nahi yahan aur bhi buddhe hai. Soch soch ke aur bhi bana badhao si. Happy", img: "02_achieve_knowledge.jpg", layout: "left" },

  { time: 112, text: "Birthday To Me, patte se chamka ke chilla kar gao Happy Birthday To Me. Ab paise waise kharche ho aur", img: "03_memory_laughs.jpg", layout: "right" },

  { time: 123, text: "Cake bhi mangwaye ho toh party khatam hone ke baad sar patakna ji. Happy Birthday To You Ji birthday to You", img: "03_memory_adventure.jpg", layout: "center" },

  { time: 130, text: "Kaisi lagi tumko meri philosophy, paida hoke bhi tumne aisa kya kiya hai. Dharti pe bojh tum bane ho Ji", img: "01_born_hero.jpg", layout: "bottom" },

  { time: 139, text: "Happy Birthday To You But You See umar chhupane ka naam hai zindagi. Mujhko bulao na bulao par batana", img: "03_memory_travel.jpg", layout: "left" },

  { time: 149, text: "Ye birthday wala song Hindi mein tumko kaisa laga hai ji? 😉🎉", img: "02_achieve_social.jpg", layout: "center" },
];

function App() {
  const [started, setStarted] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  const currentItem = [...STORYBOARD].reverse().find(s => currentTime >= s.time) || STORYBOARD[0];

  if (!started) {
    return <IntroScreen onStart={() => setStarted(true)} />;
  }

  return (
    <div className="app-container cinematic-vibe">
      <StarField />
      <MusicPlayer autoPlay={started} onTimeUpdate={setCurrentTime} />

      <div className="cinematic-bg-wrap">
        {STORYBOARD.map((s, i) => (
          <div
            key={i}
            className={`cinematic-bg-img ${currentItem.time === s.time ? 'active' : ''}`}
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/${s.img})` }}
          />
        ))}
        <div className="cinematic-overlay" />
      </div>

      <div className={`cinematic-content layout-${currentItem.layout}`}>
        <div className="kinetic-container" key={currentItem.time}>
          <div className="kinetic-word-wrap">
            {currentItem.text.split(' ').map((word, idx) => (
              <span key={idx} className="kinetic-word" style={{ animationDelay: `${idx * 0.08}s` }}>
                {word}{' '}
              </span>
            ))}
          </div>
          <div className="kinetic-accent" />
        </div>
      </div>

      <div className="cinematic-progress">
        <div className="cinematic-progress-fill" style={{ width: `${Math.min(100, (currentTime / 160) * 100)}%` }} />
      </div>
    </div>
  );
}

export default App;
